// @core/api/endpoints/resource/list_external_resources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListExternalResourcesResponse,
} from '../../../types/resource';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/resource';

/**
 * List external resources
 * Returns a paginated list of external URL resources. Supports filtering by domain and searching within title and description.
 */
export async function ListExternalResources(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListExternalResourcesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/external`;
  const requestOptions = options;
  return client.get<ListExternalResourcesResponse>(requestPath, { ...requestOptions, params });
}
